import moment from 'moment';

/** A Date field ("2016-01-01") as "January 1, 2016". */
export const formatDate = (value) =>
  value ? moment(value).format('MMMM D, YYYY') : null;

/**
 * A point in time such as `effective` as "January 1, 2016", read in Bonn.
 *
 * moment() formats in whatever timezone the code runs in: the server renders
 * in UTC, a browser in Bonn one or two hours later, so an item published late
 * in the evening showed one date in the HTML and the next day after hydration.
 */
export const formatDateTimeAsDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Europe/Berlin',
  }).format(date);
};
